import React from "react";
import { CodeBlock } from "../ui.js";
import API1 from "../../../assets/images/api1.png";

// /document-api?i=x-signature
export default function XSignature() {
  return (
    <>
              <h5 className="fw-bold">API Key Authentication</h5>
              <p>
                To authenticate API requests, you need the following
                credentials:
              </p>
              <ul>
                <li>client_id</li>
                <li>client_secret</li>
              </ul>
              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <img
                  alt="API"
                  src={API1}
                  className="w-100 my-3"
                  style={{ maxWidth: 700 }}
                />
              </div>
              <p>
                These values are used to generate a signature that must be
                included in the headers of every API request.
              </p>
              <p>
                You can find all your API connection details under the "Connect
                API" menu.
              </p>
              <p>
                <b className="text-warning">Important:</b> Your{" "}
                <b>client_secret</b> is confidential. Never share it with
                anyone.
              </p>
              <hr />
              <h5 className="fw-bold">
                APIs Requiring x-signature Authentication
              </h5>
              <p>
                For APIs that require authentication, you must include the
                following headers:
              </p>
              <ul>
                <li>
                  <b>client_id</b>, <b>client_secret</b>, <b>client_ref_id</b>,{" "}
                  <b>x-apigw-api-id</b> — your credentials, required on every
                  request
                </li>
                <li>
                  <b>x-signature</b> — The generated signature value
                </li>
                <li>
                  <b>x-timestamp</b> — The current time in epoch seconds (UNIX
                  time)
                </li>
              </ul>
              <p>
                You can generate the x-timestamp using tools like
                epochconverter.com.
              </p>
              <p>
                The timestamp can differ from the actual server time by up to
                ±30 seconds.
              </p>
              <hr />
              <h5 className="fw-bold">Generating x-signature</h5>
              <p>
                Here's an example of how to calculate the x-signature in
                Node.js:
              </p>
              <CodeBlock
                className="my-3"
                text={`const crypto = require('crypto');

const client_id = "{{client_id}}";
const client_secret = "{{client_secret}}";

// body = the exact object you send; use {} for GET requests
const XSignature = (body = {}) => {
    const timestamp = Math.floor(Date.now() / 1000).toString(); // second (Unix Time)
    const requestBody = JSON.stringify(body); // compact JSON, same key order as the request
    const dataToSign = client_id + timestamp + requestBody;
    const signature = crypto.createHmac('sha256', client_secret).update(dataToSign).digest('hex');

    return { "x-timestamp": timestamp, "x-signature": signature };
};

console.log(XSignature({ customer_id: "00000000-0000-0000-0000-000000000000", amount: 100, ref_no: "00000000001" }));`}
              />
              <ul>
                <li>
                  Sign the exact JSON you send, as compact JSON (no spaces) with
                  the keys in the same order as your request body.
                </li>
                <li>
                  The server re-serializes the body with JavaScript{" "}
                  <code>JSON.stringify</code>, so send numbers in that form (send{" "}
                  <code>100</code>, not <code>100.00</code>).
                </li>
                <li>For GET requests, sign <code>{"{}"}</code>.</li>
              </ul>
              <p>
                Include these values in your request headers to call the API.
              </p>
              <p>If the signature is valid, the API processes the request and responds with:</p>
              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <pre>
                  {`{
  "status": {
    "code": "S-2000",
    "message": "Success"
  },
  "data": { ... }
}`}
                </pre>
              </div>
              <p>
                and HTTP status 200 OK. An invalid signature returns HTTP 401 with
                code <b>P-4017</b>.
              </p>
    </>
  );
}
